module.exports = __webpack_public_path__ + "static/media/reactive_logo.be1ff4d9.png";